import { render, staticRenderFns } from "./PagoTesoreriaCursoPage.vue?vue&type=template&id=31447d47"
import script from "./PagoTesoreriaCursoPage.js?vue&type=script&lang=js&external"
export * from "./PagoTesoreriaCursoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports